import React, { useContext, useEffect, useState } from "react";
import { meiliSearchAPI } from "../../services/api/meilisearch";
import styles from "../../styles/Conversations.module.css";
import Spinner from "../UI/Spinner";
import SearchSubscribeButton from "./SearchSubscribeButton";
import { SearchContext } from "../../store/search-context";
import ConversationsUI from "./ConversationsUI";
import { PaginationContext } from "../../store/pagination-context";
import Pagination from "../Pagination/Pagination";
import { getCookie } from "../../utils/common";

const Conversations = () => {
  const searchCtx = useContext(SearchContext);
  const paginationCtx = useContext(PaginationContext);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState<{ [key: string]: any }>({});

  useEffect(() => {
    getConversations();
  }, [searchCtx.filters, paginationCtx.currentPage, paginationCtx.limit]);

  const getConversations = () => {
    setError("");
    setIsLoading(true);

    // Get all the conversations by passing empty filter object

    const tenantSlug = getCookie("current_tenant");
    meiliSearchAPI?.(tenantSlug)
      .post?.(searchCtx.filters, paginationCtx.queryString)
      .then((response) => {
        paginationCtx.updateSearchAfterId(
          response.hits[response.hits.length - 1].thread_id, response.hits[response.hits.length - 1].date
        );
        setData(response);
        searchCtx.updateConversationsCount(response.nbHits);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setError("Something went wrong. Please try again later.");
        console.log(err);
      });
  };

  return (
    <div id="all-conversations">
      <div className="d-flex justify-content-between">
        <h4>
          All Conversations ({data.nbHits && data.nbHits > 0 ? data.nbHits : 0})
        </h4>
        <SearchSubscribeButton styles={styles} />
      </div>
      {isLoading && !data.nbHits && (
        <div className="d-flex justify-content-center my-5">
          <Spinner size="md" />
        </div>
      )}
      {data.nbHits ? (
        <>
          <Pagination totalCount={data.nbHits} />
          {!isLoading && data.hits && data.hits.length > 0 ? (
            <ConversationsUI styles={styles} conversations={data.hits} />
          ) : (
            <div className="d-flex justify-content-center my-5">
              <Spinner size="md" />
            </div>
          )}
          {
            !isLoading ? 
              <Pagination totalCount={data.nbHits} /> :
              null
          }
          
        </>
      ) : !isLoading ? (
        <h3 className="d-flex justify-content-center p-5">
          No Conversations Found!
        </h3>
      ) : null}
      {!isLoading && !data.hits && !data.hits.length && <div>{error}</div>}
    </div>
  );
};

export default Conversations;
